import type { ReactElement } from 'react';
import { useContext, useEffect, useRef } from 'react';

import { Loader, LoaderSizes } from '../../components/Loader';
import AuthContext from '../../context/AuthContext';
import { resolvePostLogoutRedirectUri } from '../../hooks/keycloak/keycloakLogoutRedirect';

/**
 * Страница выхода: передаёт в Keycloak чистый post-logout redirect без OAuth hash.
 *
 * @returns {ReactElement}
 */
export function Logout(): ReactElement {
  const { logout } = useContext(AuthContext);
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) {
      return;
    }
    startedRef.current = true;

    logout(resolvePostLogoutRedirectUri()).catch((error: unknown) => {
      const errorMessage = error instanceof Error ? error.message : String(error);
      console.error('[survey-client] failed to logout', errorMessage);
    });
  }, [logout]);

  return (
    <main className='app-shell'>
      <Loader size={LoaderSizes.l} />
    </main>
  );
}
